import { Box } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { FullSaleTransactionDataFragment, DownloadFileType } from '../../../api';
import FileViewerProvider from '../../../components/FileViewerProvider';
import { useLoading } from '../../../components/LoadingProvider';
import { BasicLayoutHeader } from '../../../layouts/BasicLayout';
import useBasicStyle from '../../../layouts/BasicLayout/useBasicStyles';
import { DownloadSaleDetailFn } from '../components';
import useSaleTransactionFilename from '../hooks/useSaleTransactionFileName';
import ViewSaleTransactionBody from './ViewSaleTransactionBody';
import ViewSaleTransactionHeader from './ViewSaleTransactionHeader';

export type ViewSaleTransactionProps = {
    saleTransaction: FullSaleTransactionDataFragment;
    goToEdition: () => void;
    goToNewBidding: () => void;
    downloadSalesTransactionDetailFile: DownloadSaleDetailFn;
};

const ViewSaleTransaction = ({
    goToEdition,
    goToNewBidding,
    saleTransaction,
    downloadSalesTransactionDetailFile,
}: ViewSaleTransactionProps) => {
    const { attach } = useLoading();
    const basicStyles = useBasicStyle();

    const history = useHistory();
    const getFileName = useSaleTransactionFilename();

    const downloadFile = useCallback(
        (type: DownloadFileType) => {
            const execute = async () => {
                await downloadSalesTransactionDetailFile(
                    {
                        downloadFileType: type,
                        transactionId: saleTransaction.id,
                    },
                    getFileName({
                        type,
                        vehicleNumber: saleTransaction.vehicle?.number,
                        isListing: false,
                    })
                );
            };

            attach(execute());
        },
        [attach, downloadSalesTransactionDetailFile, getFileName, saleTransaction]
    );

    return (
        <FileViewerProvider>
            <BasicLayoutHeader onBack={history.goBack} />
            <Box className={basicStyles.mainDesktop}>
                <ViewSaleTransactionHeader
                    downloadExcel={() => downloadFile(DownloadFileType.Excel)}
                    downloadPdf={() => downloadFile(DownloadFileType.Pdf)}
                    goToEdition={goToEdition}
                    goToNewBidding={goToNewBidding}
                    saleTransaction={saleTransaction}
                />
                <ViewSaleTransactionBody saleTransaction={saleTransaction} />
            </Box>
        </FileViewerProvider>
    );
};

export default ViewSaleTransaction;
